import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6631842"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "outer-container",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "toggle-button-container" }
const _hoisted_3 = ["hidden", "title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "toggle-icon",
  class: "icon fa fa-fw mr-4 fa-circle-chevron-left"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  id: "toolbar-container",
  class: "toolbar-container",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "menu" }
const _hoisted_8 = ["hidden", "title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-flag" })
], -1))
const _hoisted_10 = { class: "button-text" }
const _hoisted_11 = ["hidden", "title"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-clipboard-list" })
], -1))
const _hoisted_13 = { class: "button-text" }
const _hoisted_14 = ["hidden", "title"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-calculator" })
], -1))
const _hoisted_16 = { class: "button-text" }
const _hoisted_17 = ["hidden", "title"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-calculator" })
], -1))
const _hoisted_19 = { class: "button-text" }
const _hoisted_20 = ["hidden", "title"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-calculator" })
], -1))
const _hoisted_22 = { class: "button-text" }
const _hoisted_23 = ["hidden", "title"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-solid fa-xmark" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-circle-half-stroke" })
], -1))
const _hoisted_27 = { class: "button-text" }
const _hoisted_28 = { class: "tool-modal" }
const _hoisted_29 = ["hidden", "title"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-solid fa-xmark" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-text-height" })
], -1))
const _hoisted_33 = { class: "button-text" }
const _hoisted_34 = { class: "tool-modal" }
const _hoisted_35 = ["hidden", "title"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-solid fa-xmark" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-magnifying-glass" })
], -1))
const _hoisted_39 = { class: "button-text" }
const _hoisted_40 = { class: "tool-modal" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "zoom-level" }, "100%", -1))
const _hoisted_42 = { class: "button-row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-minus" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-plus" }, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["hidden", "title"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-solid fa-xmark" }, null, -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-grip-lines" })
], -1))
const _hoisted_51 = { class: "button-text" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tool-modal",
  style: {"display":"none"}
}, null, -1))
const _hoisted_53 = ["title", "hidden"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-solid fa-xmark" }, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-highlighter" })
], -1))
const _hoisted_57 = { class: "button-text" }
const _hoisted_58 = { class: "tool-modal" }
const _hoisted_59 = { class: "btn-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-regular fa-trash-can" }, null, -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = ["hidden", "title"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-solid fa-xmark" }, null, -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-text-slash" })
], -1))
const _hoisted_66 = { class: "button-text" }
const _hoisted_67 = { class: "tool-modal" }
const _hoisted_68 = { id: "zoom-level" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-arrows-rotate" }, null, -1))
const _hoisted_70 = ["hidden", "title"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-wr fa-book" })
], -1))
const _hoisted_72 = { class: "button-text" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tool-modal",
  style: {"display":"none"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        id: "toggle-list-button",
        hidden: _ctx.hideExpandButton,
        title: _ctx.$t('btn.expand_menu'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expandList && _ctx.expandList(...args)))
      }, _hoisted_5, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          id: "btn-flag-item",
          class: "menu-button",
          hidden: !_ctx.showButton('flag_item'),
          title: _ctx.$t('btn.flag')
        }, [
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.togglePnpTool('flag_item')))
          }, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('btn.flag')), 1)
            ])
          ])
        ], 8, _hoisted_8),
        _createElementVNode("button", {
          id: "btn-notepad",
          class: "menu-button",
          hidden: !_ctx.showButton('notepad'),
          title: _ctx.$t('toolbar.notepad')
        }, [
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglePnpTool('notepad')))
          }, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.notepad')), 1)
            ])
          ])
        ], 8, _hoisted_11),
        _createElementVNode("button", {
          id: "btn-basic-calculator",
          class: "menu-button",
          hidden: !_ctx.showButton('basic-calculator'),
          title: _ctx.$t('toolbar.calc_basic')
        }, [
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePnpTool('basic-calculator')))
          }, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.calc_basic')), 1)
            ])
          ])
        ], 8, _hoisted_14),
        _createElementVNode("button", {
          id: "btn-scientific-calculator",
          class: "menu-button",
          hidden: !_ctx.showButton('scientific-calculator'),
          title: _ctx.$t('toolbar.calc_sci')
        }, [
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.togglePnpTool('scientific-calculator')))
          }, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.calc_sci')), 1)
            ])
          ])
        ], 8, _hoisted_17),
        _createElementVNode("button", {
          id: "btn-graphing-calculator",
          class: "menu-button",
          hidden: !_ctx.showButton('graphing-calculator'),
          title: _ctx.$t('toolbar.calc_graph')
        }, [
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.togglePnpTool('graphing-calculator')))
          }, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.calc_graph')), 1)
            ])
          ])
        ], 8, _hoisted_20),
        _createElementVNode("button", {
          id: "btn-color-scheme",
          class: "menu-button",
          hidden: !_ctx.showButton('color_scheme'),
          title: _ctx.$t('toolbar.color')
        }, [
          _createElementVNode("div", {
            class: "floating-close-button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleTool('btn-color-scheme')))
          }, _hoisted_25),
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleTool('btn-color-scheme')))
          }, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.color')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", {
              id: "black-white",
              class: "tool-button selected",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.colorContrastSelected('black-white')))
            }, _toDisplayString(_ctx.$t('toolbar.colors.black_white')), 1),
            _createElementVNode("div", {
              id: "gray-gray",
              class: "tool-button",
              style: {"background":"#e7e7e7","color":"#44484"},
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.colorContrastSelected('gray-gray')))
            }, _toDisplayString(_ctx.$t('toolbar.colors.gray_lt')), 1),
            _createElementVNode("div", {
              id: "purple-green",
              class: "tool-button",
              style: {"background":"#bde0cd","color":"##a84676"},
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.colorContrastSelected('purple-green')))
            }, _toDisplayString(_ctx.$t('toolbar.colors.purple_lt')), 1),
            _createElementVNode("div", {
              id: "black-violet",
              class: "tool-button",
              style: {"background":"#ce9fce"},
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.colorContrastSelected('black-violet')))
            }, _toDisplayString(_ctx.$t('toolbar.colors.black_violet')), 1),
            _createElementVNode("div", {
              id: "yellow-navy",
              class: "tool-button",
              style: {"background":"#2a4376","color":"#f7ed60"},
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.colorContrastSelected('yellow-navy')))
            }, _toDisplayString(_ctx.$t('toolbar.colors.yellow_navy')), 1),
            _createElementVNode("div", {
              id: "white-black",
              class: "tool-button",
              style: {"background":"#000000","color":"#ffffff"},
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.colorContrastSelected('white-black')))
            }, _toDisplayString(_ctx.$t('toolbar.colors.white_black')), 1)
          ])
        ], 8, _hoisted_23),
        _createElementVNode("button", {
          id: "btn-font-size",
          class: "menu-button",
          hidden: !_ctx.showButton('font_size'),
          title: _ctx.$t('toolbar.font')
        }, [
          _createElementVNode("div", {
            class: "floating-close-button",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleTool('btn-font-size')))
          }, _hoisted_31),
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggleTool('btn-font-size')))
          }, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.font')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", {
              id: "font-size-x-small",
              class: "tool-button",
              style: {"font-size":"x-small"},
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.fontSizeSelected('x-small')))
            }, _toDisplayString(_ctx.$t('toolbar.font_xs')), 1),
            _createElementVNode("div", {
              id: "font-size-smaller",
              class: "tool-button",
              style: {"font-size":"smaller"},
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.fontSizeSelected('smaller')))
            }, _toDisplayString(_ctx.$t('toolbar.font_sm')), 1),
            _createElementVNode("div", {
              id: "font-size-normal",
              class: "tool-button selected",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.fontSizeSelected('normal')))
            }, _toDisplayString(_ctx.$t('toolbar.font_normal')), 1),
            _createElementVNode("div", {
              id: "font-size-larger",
              class: "tool-button",
              style: {"font-size":"larger"},
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.fontSizeSelected('larger')))
            }, _toDisplayString(_ctx.$t('toolbar.font_lg')), 1),
            _createElementVNode("div", {
              id: "font-size-x-large",
              class: "tool-button",
              style: {"font-size":"x-large"},
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.fontSizeSelected('x-large')))
            }, _toDisplayString(_ctx.$t('toolbar.font_xl')), 1)
          ])
        ], 8, _hoisted_29),
        _createElementVNode("button", {
          id: "btn-zoom",
          class: "menu-button",
          hidden: !_ctx.showButton('zoom'),
          title: _ctx.$t('toolbar.zoom')
        }, [
          _createElementVNode("div", {
            class: "floating-close-button",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toggleTool('btn-zoom')))
          }, _hoisted_37),
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleTool('btn-zoom')))
          }, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.zoom')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                id: "btn-zoom-decrease",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.zoomSelected('decrease')))
              }, _hoisted_44),
              _createElementVNode("button", {
                id: "btn-zoom-increase",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.zoomSelected('increase')))
              }, _hoisted_46)
            ]),
            _createElementVNode("div", {
              class: "tool-button",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.zoomSelected('reset')))
            }, _toDisplayString(_ctx.$t('btn.reset')), 1)
          ])
        ], 8, _hoisted_35),
        _createElementVNode("button", {
          id: "btn-line-reader",
          class: "menu-button",
          hidden: !_ctx.showButton('line_reader'),
          title: _ctx.$t('toolbar.line_reader')
        }, [
          _createElementVNode("div", {
            class: "floating-close-button",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.lineReaderSelected()))
          }, _hoisted_49),
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.lineReaderSelected()))
          }, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.line_reader')), 1)
            ])
          ]),
          _hoisted_52
        ], 8, _hoisted_47),
        _createElementVNode("button", {
          id: "btn-highlighter",
          class: "menu-button",
          title: _ctx.$t('toolbar.highlighter'),
          hidden: !_ctx.showButton('highlighter')
        }, [
          _createElementVNode("div", {
            class: "floating-close-button",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.toggleTool('btn-highlighter'))),
            onTouchstart: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.toggleTool('btn-highlighter')), ["prevent"]))
          }, _hoisted_55, 32),
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.toggleTool('btn-highlighter'))),
            onTouchstart: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.toggleTool('btn-highlighter')), ["prevent"]))
          }, [
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.highlighter')), 1)
            ])
          ], 32),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                style: {"background-color":"#fbff7b"},
                onTouchstart: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.highlightText('yellow')), ["prevent"])),
                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.highlightText('yellow')))
              }, null, 32),
              _createElementVNode("button", {
                style: {"background-color":"#f9aad3"},
                onTouchstart: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.highlightText('magenta')), ["prevent"])),
                onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.highlightText('magenta')))
              }, null, 32),
              _createElementVNode("button", {
                style: {"background-color":"#7aed89"},
                onTouchstart: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.highlightText('green')), ["prevent"])),
                onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.highlightText('green')))
              }, null, 32),
              _createElementVNode("button", {
                style: {"background-color":"#55fffd"},
                onTouchstart: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (_ctx.highlightText('cyan')), ["prevent"])),
                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.highlightText('cyan')))
              }, null, 32)
            ]),
            _createElementVNode("button", {
              onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.clearHighlights()))
            }, _hoisted_61)
          ])
        ], 8, _hoisted_53),
        _createElementVNode("button", {
          id: "btn-choice-masking",
          class: "menu-button",
          hidden: !_ctx.showButton('choice_masking'),
          title: _ctx.$t('toolbar.mask_choice')
        }, [
          _createElementVNode("div", {
            class: "floating-close-button",
            onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.choiceMaskingSelected()))
          }, _hoisted_64),
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.choiceMaskingSelected()))
          }, [
            _hoisted_65,
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.mask_choice')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('toolbar.mask_choice_info')), 1),
            _createElementVNode("div", {
              class: "tool-button",
              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.choiceMaskingReset()))
            }, [
              _hoisted_69,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('btn.reset')), 1)
            ])
          ])
        ], 8, _hoisted_62),
        _createElementVNode("button", {
          id: "btn-dictionary",
          class: "menu-button",
          hidden: !_ctx.showButton('dictionary'),
          title: _ctx.$t('toolbar.dictionary')
        }, [
          _createElementVNode("div", {
            class: "inner-container",
            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.showDictionary()))
          }, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.dictionary')), 1)
            ])
          ]),
          _hoisted_73
        ], 8, _hoisted_70)
      ])
    ])
  ]))
}